import { useAggregationStore } from '../stores/aggregationStore'

/**
 * Returns the org's detected rating scale max — `5` for forms that use a
 * 1-5 rating component, `10` otherwise. Defaults to `10` until the
 * dashboard summary has loaded so callers can render badges immediately
 * with the safe (legacy) bucket boundaries.
 *
 * Use together with `getRatingColor(value, scaleMax)` so badges colour
 * correctly on 1-5 forms (a 4.83 lands in Excellent green, not Average
 * orange).
 */
export function useRatingScaleMax(): number {
	return useAggregationStore((s) => s.summary?.ratingScaleMax ?? 10)
}
